export const PublicAccessType = {
  VIEW: 'VIEW',
  BOOK: 'BOOK',
  NONE: 'NONE',
  PUBLIC_ONLY: 'PUBLIC_ONLY',
};

export const publicAccessTypes = [
  PublicAccessType.BOOK,
  PublicAccessType.VIEW,
  PublicAccessType.NONE,
  PublicAccessType.PUBLIC_ONLY,
];
